<script setup lang="ts">
import { cardActions } from "@/action/cardActions";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { action } from "@/components/action/action";
import { dropdownKey } from "@/components/ui/DropdownMenu/injectKeys";
import MenuList from "@/components/ui/MenuList/MenuList.vue";
import MenuListItem from "@/components/ui/MenuList/MenuListItem.vue";
import MenuListItems from "@/components/ui/MenuList/MenuListItems.vue";
import { injectStrict } from "@/utils/vue";

const card = injectStrict(cardKey);
const dropdown = injectStrict(dropdownKey);
</script>

<template>
  <MenuList role="dialog">
    <MenuListItems role="menu">
      <MenuListItem
        v-autofocus="dropdown.autofocus?.value !== false"
        v-bind="action(cardActions.shareLink, { click: dropdown.close }, card)"
        :icon="null"
      >
        {{ $t("label.actionMenu.stickyLinkToClipboard", 1) }}
      </MenuListItem>
      <MenuListItem
        v-if="card.almIssueUrl"
        v-bind="action(cardActions.shareAlmLink, { click: dropdown.close }, card)"
      />
      <MenuListItem
        v-if="card.almId"
        v-bind="action(cardActions.shareAlmId, { click: dropdown.close }, card)"
      />
    </MenuListItems>
  </MenuList>
</template>
